import { render, staticRenderFns } from "./Colors.vue?vue&type=template&id=0d22a1de&scoped=true"
import script from "./Colors.vue?vue&type=script&lang=js"
export * from "./Colors.vue?vue&type=script&lang=js"
import style0 from "./Colors.vue?vue&type=style&index=0&id=0d22a1de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d22a1de",
  null
  
)

export default component.exports